<template>
    <form method="post">
        <div class="inputs-name">
            <div>
                <label for="input-firstname">Prénom *</label>
                <input
                    style="margin: 0"
                    v-model="data.user.firstname"
                    :class="v && isError(v.user.firstname) ? 'error' : null"
                    type="text"
                    id="input-firstname"
                    required
                />
                <ErrorMessage
                    v-if="v && isError(v.user.firstname) && data.user.firstname.length === 0"
                    input="input-firstname"
                    message="Ce champ est nécessaire"
                />
                <ErrorMessage
                    v-if="v && isError(v.user.firstname) && data.user.firstname.length > 0"
                    input="input-firstname"
                    message="Caractères uniquement"
                />
            </div>

            <div>
                <label for="input-name">Nom *</label>
                <input
                    style="margin: 0"
                    v-model="data.user.name"
                    :class="v && isError(v.user.name) ? 'error' : null"
                    type="text"
                    id="input-name"
                    required
                />
                <ErrorMessage
                    v-if="v && isError(v.user.name) && data.user.name.length === 0"
                    message="Ce champ est nécessaire"
                />
                <ErrorMessage
                    v-if="v && isError(v.user.name) && data.user.name.length > 0"
                    message="Caractères uniquement"
                />
            </div>
        </div>

        <label for="input-email">Email *</label>
        <input
            v-model="data.user.email"
            :class="v && isError(v.user.email) ? 'error' : null"
            type="email"
            id="input-email"
            required
        />
        <ErrorMessage
            v-if="v && isError(v.user.email) && data.user.email.length === 0"
            message="Ce champ est nécessaire"
        />
        <ErrorMessage
            v-if="v && isError(v.user.email) && data.user.email.length > 0"
            message="Adresse invalide"
        />
        <label for="input-tel">Téléphone *</label>
        <input
            v-model="data.user.tel"
            :class="v && isError(v.user.tel) ? 'error' : null"
            type="tel"
            id="input-tel"
            required
        />
        <ErrorMessage
            v-if="v && isError(v.user.tel) && data.user.tel.length === 0"
            message="Ce champ est nécessaire"
        />
        <ErrorMessage
            v-if="v && isError(v.user.tel) && data.user.tel.length > 0"
            message="Numéro invalide"
        />

        <label for="input-birthday">Date de naissance *</label>
        <InputVCalendar
            v-model="data.user.birthday"
            :error="v && isError(v.user.birthday)"
            id="input-birthday"
        ></InputVCalendar>
        <ErrorMessage v-if="v && isError(v.user.birthday)" message="Ce champ est nécessaire" />

        <label for="input-birthplace">Lieu de naissance *</label>
        <input
            v-model="data.user.birthplace"
            :class="v && isError(v.user.birthplace) ? 'error' : null"
            type="email"
            id="input-birthplace"
            required
        />
        <ErrorMessage v-if="v && isError(v.user.birthplace)" message="Ce champ est nécessaire" />

        <label for="input-address">Adresse *</label>
        <input
            v-model="data.user.addressLine1"
            :class="v && isError(v.user.addressLine1) ? 'error' : null"
            type="text"
            placeholder="Adresse"
            id="input-address-line1"
            required
        />
        <ErrorMessage v-if="v && isError(v.user.addressLine1)" message="Ce champ est nécessaire" />

        <input
            style="margin-top: 1rem"
            v-model="data.user.addressLine2"
            type="text"
            placeholder="Complément d'adresse"
            id="input-address-line2"
        />

        <div class="inputs-location">
            <div>
                <input
                    v-model="data.user.city"
                    :class="v && isError(v.user.city) ? 'error' : null"
                    type="text"
                    placeholder="Ville"
                    id="input-city"
                    required
                />
                <ErrorMessage v-if="v && isError(v.user.city)" message="Ce champ est nécessaire" />
            </div>

            <div>
                <input
                    v-model="data.user.state"
                    type="text"
                    placeholder="État / Province / Région"
                    id="input-state"
                    required
                />
            </div>

            <div>
                <input
                    v-model="data.user.zipcode"
                    :class="v && isError(v.user.zipcode) ? 'error' : null"
                    type="text"
                    placeholder="Code postal"
                    id="input-zipcode"
                    required
                />
                <ErrorMessage
                    v-if="v && isError(v.user.zipcode) && data.user.zipcode.length === 0"
                    message="Ce champ est nécessaire"
                />
                <ErrorMessage
                    v-if="v && isError(v.user.zipcode) && data.user.zipcode.length > 0"
                    message="Code postal invalide"
                />
            </div>
            <div>
                <select
                    v-model="data.user.country"
                    :class="v && isError(v.user.country) ? 'error' : null"
                    name="country"
                    id="input-address-country"
                    required
                >
                    <option
                        v-for="(country, index) in countries"
                        :key="index"
                        :value="country"
                    >{{ country }}</option>
                </select>
                <ErrorMessage
                    v-if="v && isError(v.user.country)"
                    message="Ce champ est nécessaire"
                />
            </div>
        </div>
    </form>
</template>

<script>
import countriesJson from '../../assets/countries-FR.json';
import { state } from "../../store";
import { isError } from '../../validation';
import ErrorMessage from '../errors/ErrorMessage.vue';
import InputVCalendar from '../Inputs/InputVCalendar.vue';

export default {
    name: "FirstStep",
    components: { ErrorMessage, InputVCalendar },
    props: {
        v: {
            type: Object
        }
    },
    setup() {
        const countries = countriesJson;
        const data = state;

        return { countries, data, isError };
    }
}
</script>

<style lang='scss' scoped>
.inputs-name {
    display: flex;
    div {
        label {
            display: block;
        }

        &:last-child {
            margin-left: 1rem;
        }
    }
}

.inputs-location {
    display: flex;
    flex-wrap: wrap;

    div {
        input,
        select {
            width: 80%;
            margin-top: 1rem;
        }
    }
}
</style>
